import React from "react";

// LIVON butterfly — uses the official logo asset cropped to just the butterfly.
// Kept as a React component so it can drop into every place the previous SVG was used.
export const Butterfly = ({ size = 28, className = "", style = {} }) => (
  <img
    src="/livon-butterfly.png"
    alt="LIVON butterfly"
    width={size}
    height={size}
    className={className}
    style={{
      width: size,
      height: size,
      objectFit: "contain",
      display: "block",
      ...style,
    }}
    draggable={false}
    aria-hidden="true"
  />
);

// Full LIVON logo (butterfly + wordmark) — for header / footer hero mark
export const LivonLogo = ({ height = 44, className = "", style = {} }) => (
  <img
    src="/livon-logo.png"
    alt="LIVON"
    className={className}
    style={{
      height,
      width: "auto",
      objectFit: "contain",
      display: "block",
      ...style,
    }}
    draggable={false}
  />
);

// LIVON wordmark with trademark — kept for places that still render LIVON® as text
export const LivonMark = ({ className = "", trademark = true, supSize = "0.45em" }) => (
  <span className={className} style={{ display: "inline-flex", alignItems: "flex-start" }}>
    <span>LIVON</span>
    {trademark && (
      <span
        style={{
          fontSize: supSize,
          marginLeft: "0.18em",
          marginTop: "0.55em",
          fontFamily: "Outfit, sans-serif",
          fontWeight: 300,
          letterSpacing: 0,
          lineHeight: 1,
          display: "inline-block",
          verticalAlign: "baseline",
        }}
        aria-label="registered trademark"
      >
        ®
      </span>
    )}
  </span>
);
